import { Button } from 'antd';
import * as React from 'react';
import "./StandardButton.scss";
import { ButtonProps } from 'antd/lib/button/button';

export interface IStandardButton {
    preset?: "normal" | "outline"
}

export default class StandardButton extends React.Component<IStandardButton & ButtonProps, {}> {
    public static defaultProps = {
        preset: "normal"
    } as IStandardButton;

    public render() {
        let classes = `pbr-std-btn ${this.props.preset === "normal"
            ? "pbr-std-btn-normal" : "pbr-std-btn-outline"} `;

        if (this.props.className) {
            classes += this.props.className;
        }
        const props = { ...this.props, className: classes };

        return (
            <Button {...props} block={this.props.block === undefined || this.props.block} style={{ maxWidth: "324px", ...this.props.style }}>
                {this.props.children}
            </Button >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/StandardButton/StandardButton.tsx